module.exports = __webpack_public_path__ + "img/autospin_btn.f74f89ad.png";